<template>
<!-- 物资管理 -->
    <div class="declare-view">
        <div class="table-title">
            <Row type="flex">
                <div class="boxs-div">
                    <span class="input-label">物资分类：</span>
                    <span class="Cascader">
                        <Cascader
                            :data="productClassifyData"
                            v-model="productClassify"
                            @on-change="productClassifyChange"></Cascader>
                    </span>
                </div>
                <div class="boxs-div" style="margin-left: 20px;margin-right: 20px">
                    <span class="input-label">物资名称：</span>
                    <span class="Cascader">
                        <Input placeholder="请输入物资名称"
                            v-model="productByClassifyVar.productName"/>
                    </span>
                </div>
                <div class="boxs-div">
                    <span class="input-label">p码：</span>
                    <span class="Cascader">
                        <Input placeholder="请输入物资编码"
                            v-model="productByClassifyVar.productNo"/>
                    </span>
                    <Button
                        style="margin-left: 16px"
                        type="primary"
                        @click="handleSearch">
                        搜索
                    </Button>
                    <Button
                        style="margin-left: 16px"
                        @click="handleReset">
                        重置
                    </Button>
                </div>

            </Row>
        </div>
        <div style="margin-top: 14px">
            <Table
                :columns="columns"
                :data="list"
                :height="520"
                ref="list">
                <template slot-scope="{ row }" slot="action">
                    <Button size="small" type="primary" @click="addSpec(row)">同步</Button>
                </template>
            </Table>
            <div class="pages-footer">
                <Page
                    :current="productByClassifyVar.pageNumber"
                    :total="listTotal"
                    show-sizer
                    :page-size="productByClassifyVar.pageSize"
                    @on-page-size-change="getChangePageSize"
                    @on-change="getChangePageNum"/>
            </div>
        </div>
        <Modal
            class="model-postion-setting"
            v-model="model"
            title="同步">
            <div class="history-order">
                <span>确定要同步物资{{product.productname}}吗?</span>
            </div>
            <template slot="footer">
                <span class="his-cancel" @click="model = false">取消</span>
                <span class="his-ok" @click="submit">确定</span>
            </template>
        </Modal>
    </div>
</template>

<script>
import { queryProductClassify, queryProductByClassifyNo, syncProduct } from '@/graphql/graphql.js';
import Cookies from 'js-cookie';
import { creatMultidimensionalArray } from '@/assets/js/creatArr.js';

export default {
    data() {
        return {
            productClassify: [],
            productClassifyData: [],
            productName: '',
            productByClassifyVar: {
                pageNumber: 1,
                pageSize: 20,
                classifyNo: '',
                cliqueNo: Cookies.getJSON('cliqueNo').toString(),
                productName: '',
                productNo: ''
            },
            list: [],
            listTotal: 0,
            columns: [
                {
                    title: '物资名称',
                    key: 'productname',
                    minWidth: 100
                },
                {
                    title: '物资编码',
                    key: 'productno',
                    minWidth: 90
                },
                {
                    title: 'SPU码',
                    key: 'productspu',
                    minWidth: 120
                },
                {
                    title: '物资分类',
                    key: 'classifyname',
                    minWidth: 120
                },
                {
                    title: '物资规格',
                    key: 'productspectype',
                    minWidth: 100
                },
                {
                    title: '物资单位',
                    key: 'productunit',
                    minWidth: 100
                },
                {
                    title: '物资描述',
                    key: 'productspec',
                    minWidth: 100
                },
                {
                    title: '操作',
                    slot: 'action',
                    minWidth: 100
                }
            ],
            pageInfo: {
                classify: []
            },
            product: {},
            model: false
        };
    },
    mounted() {
        this.getProductClassify();
        this.getProductByClassifyNo();
    },
    methods: {
        // 同步
        addSpec(row) {
            this.model = true;
            this.product = row;
        },
        submit() {
            this.$apollo.mutate({
                mutation: syncProduct,
                context: { useApi1: false },
                variables: {
                    productNo: this.product.productno
                }
            }).then(res => {
                const data = res.data.syncProduct;
                if (data && data.code === 200) {
                    this.$setNotice('同步成功');
                    this.model = false;
                } else {
                    this.$Message.error(data.message);
                }
            });
        },
        // 获取物资分类的联级列表
        getProductClassify() {
            this.$apollo.query({
                query: queryProductClassify,
                variables: {
                    cliqueNo: `${Cookies.getJSON('cliqueNo')}`,
                    supplierNo: `${Cookies.getJSON('USER-INFO').supplierNo}`
                },
                fetchPolicy: 'network-only'
            }).then(res => {
                const data = res.data.queryProductClassify;
                if (data && data.data && data.code === 200) {
                    let parentData = [];
                    for (let i = 5;i > 0;i -= 1) {
                        if (data.data[i.toString()].length) {
                            parentData = creatMultidimensionalArray(
                                data.data[i.toString()],
                                parentData,
                                'classifyParentNo',
                                'classifyName',
                                'classifyNo'
                            );
                        } else {
                            continue;
                        }
                    }
                    parentData.forEach(ele => {
                        let classifyName, classifyNo, children, value, label;
                        ({ classifyName: label, classifyNo: value, children } = ele);
                        this.productClassifyData.push({
                            value,
                            label,
                            children
                        });
                    });
                } else {
                    this.$setNotice('分类列表获取失败，刷新试试吧');
                }
            });
        },
        // 获取物资列表
        getProductByClassifyNo() {
            this.$apollo.query({
                query: queryProductByClassifyNo,
                variables: this.productByClassifyVar,
                fetchPolicy: 'network-only'
            }).then(res => {
                const data = res.data.queryProductByClassifyNo;
                if (data && data.data && data.code === 200) {
                    this.listTotal = data.count;
                    this.list = data.data;
                }
            });
        },
        handleSearch() {
            this.productByClassifyVar.pageNumber = 1;
            this.getProductByClassifyNo();
        },
        handleReset() {
            this.productByClassifyVar.pageNumber = 1;
            this.productByClassifyVar.productName = '';
            this.productByClassifyVar.classifyNo = '';
            this.productByClassifyVar.productNo = '';
            this.productClassify = [];
            this.getProductByClassifyNo();
        },
        // 选中物资分类
        productClassifyChange(val) {
            this.pageInfo.classify = val;
            this.productByClassifyVar.productName = '';
            this.productByClassifyVar.productNo = '';
            this.productByClassifyVar.classifyNo = val[val.length - 1] || '';
        },
        getChangePageNum(val) {
            this.productByClassifyVar.pageNumber = val;
            this.getProductByClassifyNo();
        },
        // pagesize 变化
        getChangePageSize(size) {
            this.productByClassifyVar.pageSize = size;
            this.getProductByClassifyNo();
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/views/metarilas/index.vue